module.exports = __webpack_public_path__ + "img/About us.0b9da191.svg";